import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatOption, MatOptionModule } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { provideNgxMask } from 'ngx-mask'
import moment from 'moment/moment'
import { CommonModule } from '@angular/common'
import { map, Observable, startWith } from 'rxjs'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { TariffTypeService } from '../../../../core/services/tariff/tariff-type/tariff-type.service'
import { DriverTypeService } from '../../../../core/services/driver/driver-type/driver-type.service'
import { LocationService } from '../../../../core/services/location/location/location.service'
import { ServiceTypeService } from '../../../../core/services/service/service-type/service-type.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ServiceSpecificationService } from '../../../../core/services/service/service-specification/service-specification.service'
import { PurchasesQuoteRequestService } from '../../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { convertCurrency, removeAccents } from '../../../../shared/utils/utils'
import { ModalSupplierComponent } from '../../../person/supplier/modal_supplier/modal-supplier.component'
import { ModalLegalEntityClientComponent } from '../../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { DialogChooseUniqueNewComponent } from '../../../../shared/components/dialog-to-choose-unique-new/dialog-to-choose-unique-new.component'
interface LocationModel {
  id: number
  descricao: string
}

@Component({
  imports: [
    CommonModule,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatSlideToggle,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    MatOptionModule,
    MatAutocompleteModule,
  ],
  providers: [
    TariffService,
    TariffTypeService,
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    provideNgxMask(),
  ],
  selector: 'model-purchases-quote-tariff-create',
  standalone: true,
  styleUrl: './model-purchases-quote-tariff-create.component.scss',
  templateUrl: './model-purchases-quote-tariff-create.component.html',
})
export class ModelPurchasesQuoteTariffCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private tariffService: TariffService,
    private purchasesQuoteRequestService: PurchasesQuoteRequestService,
    private tariffTypeService: TariffTypeService,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModelPurchasesQuoteTariffCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data) {
      this.item = data.quote
      this.supplier = data.supplier
      this.proposal = data.proposal
    }
  }
  datepicker = viewChild<MatDatepicker<any>>('birth')
  @Output() responseEdit = new EventEmitter()
  @Output() responseCancel = new EventEmitter()

  filteredOrigins!: Observable<LocationModel[]>
  filteredDestinations!: Observable<LocationModel[]>
  displayLocation = (loc: LocationModel | null): string =>
    loc ? loc.descricao : ''

  // item: any = { user: false, data: [] }
  item: any = {}
  supplier: any = {}
  proposal: any = {}

  form: FormGroup = new FormGroup({})
  loading = false
  listTypeTariff: any[] = []
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listServiceSpecification: any[] = []

  clientSelected: any = {}
  supplierSelected: any = {}

  ngOnInit(): void {
    this.getTypeTariff()
    // this.getLocation()
    // this.getTypeService()
    // this.getTypeVehicle()
    // this.getTypeDriver()
    // this.getServiceSpecification(this.item.tipoServicoId, true)
    this.createForm()
  }

  getTypeTariff() {
    this.tariffTypeService.listTariffType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeTariff = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getLocation(): void {
    this.locationService.listLocation().subscribe({
      next: (resp: ResponseRequestModel) => {
        this.listLocation = resp.data

        this.initOriginFilter()

        const originItem = this.listLocation.find(
          (c) => c.id === this.item.origemId,
        )
        const destinationItem = this.listLocation.find(
          (c) => c.id === this.item.destinoId,
        )

        if (originItem) {
          this.form.get('origin')!.setValue(originItem)
        }
        if (destinationItem) {
          this.form.get('destination')!.setValue(destinationItem)
        }
      },
      error: (err: any) => {
        console.error(err)
      },
    })
  }

  private initOriginFilter(): void {
    this.filteredOrigins = this.form.get('origin')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        // Converte para string (tratando objetos LocationModel)
        if (typeof v === 'string') return v
        if (v && typeof v.descricao === 'string') return v.descricao
        if (v && typeof v.estado === 'string') return v.estado
        return ''
      }),
      map((text) => removeAccents(text.toLowerCase())),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locState = loc?.estado || ''
          return (
            removeAccents(locDescription.toLowerCase()).includes(searchText) ||
            removeAccents(locState.toLowerCase()).includes(searchText)
          )
        })
      }),
    )

    this.filteredDestinations = this.form.get('destination')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        if (typeof v === 'string') return v
        if (v && typeof v.descricao === 'string') return v.descricao
        if (v && typeof v.estado === 'string') return v.estado
        return ''
      }),
      map((text) => removeAccents(text.toLowerCase())),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locState = loc?.estado || ''
          return (
            removeAccents(locDescription.toLowerCase()).includes(searchText) ||
            removeAccents(locState.toLowerCase()).includes(searchText)
          )
        })
      }),
    )
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
  }

  getServiceSpecification(idType: number, checkLoad = false) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (checkLoad) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == this.item.servicoId
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  selectTypeTariff(item: any) {
    if (item.value == '1') {
      this.form.get('exclusiveCustomer')?.setValue('N')
      this.form.get('exclusiveCustomer')?.disable()
    } else if (item.value == '2') {
      this.form.get('exclusiveCustomer')?.setValue('S')
      this.form.get('exclusiveCustomer')?.disable()
    } else {
      this.form.get('exclusiveCustomer')?.enable()
    }
  }

  editTariff() {
    this.loading = true
    const model = this.createModel()
    this.purchasesQuoteRequestService
      .CreatePurchasesQuoteRequestTariff(model)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.responseEdit.emit(true)
          this.close()
        },
        error: (err: any) => {
          if (err.error.statusCode == 409) {
            this.dialogChooseUnique(model)
            this.loading = false
            // this.snackbar.error(err.error.data.message)
            // this.dialogChooseStandard(model, err.error.data.id)
          } else {
            this.loading = false
            this.snackbar.errorRequest(err)
          }
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
  }

  dialogChooseUnique(model: any) {
    const dialogRef = this.dialog.open(DialogChooseUniqueNewComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: '',
    })
    dialogRef.componentInstance.responseTariff.subscribe((response: any) => {
      if (response) {
        this.cancelSendProposalClient(model)
        // this.createTariffUnique(model)
        dialogRef.close()
      } else {
        dialogRef.close()
      }
    })
  }

  cancelSendProposalClient(model: any) {
    this.purchasesQuoteRequestService
      .calcelarTariffPurchase({ itemCotacaoId: model.itemCotacaoId })
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCancel.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          // this.form.reset()
        },
      })
  }

  createTariffUnique(model: any) {
    this.loading = true
    this.purchasesQuoteRequestService
      .CreatePurchasesQuoteRequestTariffUnique(model)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseEdit.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          // this.form.reset()
        },
      })
  }

  validClient() {
    if (this.form.get('tariffType')!.value != 1 && !this.clientSelected.id) {
      return false
    } else {
      return true
    }
  }

  checkForm() {
    // if (this.form.valid && this.validClient()) {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      itemCotacaoId: this.supplier.id,
      tipoTarifarioId: this.form.get('tariffType')?.value,
      dataValidade: moment(this.form.get('validity')!.value).format(
        'DD/MM/YYYY',
      ),
      perimetroUrbano: this.form.get('urbanPerimeter')!.value ? 'S' : 'N',
      enviarEmail: 'N',
      exclusivoCliente: this.form.get('exclusiveCustomer')!.value
        ? this.form.get('exclusiveCustomer')!.value
        : 'N',
    }

    // return {
    //   id: this.item.id,
    //   tipoId: this.form.get('tariffType')!.value,
    //   origemId: this.form.get('origin')!.value?.id ?? 0,
    //   destinoId: this.form.get('destination')!.value?.id ?? 0,
    //   tipoServicoId: this.form.get('serviceType')!.value,
    //   servicoId: this.form.get('specificationService')!.value,
    //   tipoVeiculoId:
    //     this.form.get('vehicleType')!.value != ''
    //       ? this.form.get('vehicleType')!.value
    //       : 0,
    //   tipoMotoristaId:
    //     this.form.get('driverType')!.value != ''
    //       ? this.form.get('driverType')!.value
    //       : 0,
    //   clienteId: this.clientSelected.id ? this.clientSelected.id : 0,
    //   fornecedorId: this.supplierSelected.id ? this.supplierSelected.id : 0,
    //   custo: convertCurrency(this.form.get('cost')!.value),
    //   custoHoraExtra: convertCurrency(this.form.get('costOvertime')!.value),
    //   custoKmExtra: convertCurrency(this.form.get('costKmExtra')!.value),
    //   // ativo: this.form.get('active')!.value ? 'S' : 'N',
    //   ativo: 'S',
    //   dataValidade: moment(this.form.get('validity')!.value).format(
    //     'DD/MM/YYYY',
    //   ),
    //   perimetroUrbano: this.form.get('urbanPerimeter')!.value ? 'S' : 'N',
    //   standard: this.form.get('standard')!.value ? 'S' : 'N',
    // }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariffType: ['', [Validators.required]],
      serviceType: ['', [Validators.required]],
      specificationService: ['', [Validators.required]],
      vehicleType: [''],
      driverType: [''],
      origin: ['', [Validators.required]],
      destination: ['', [Validators.required]],
      cost: ['', [Validators.required]],
      costOvertime: ['', [Validators.required]],
      costKmExtra: ['', [Validators.required]],
      validity: ['', [Validators.required]],
      exclusiveCustomer: ['N', [Validators.required]],
      // active: [''],
      // client: [''],
      // supplier: [''],
      // standard: [false],
      urbanPerimeter: [true],
    })
    this.fillForm()
  }

  fillForm() {
    // this.form.get('client')!.disable()
    // if (this.item.tipoId == 1) {
    // } else if (this.item.tipoId == 2) {
    //   this.form.get('tariffType')!.disable()
    //   this.clientSelected = {
    //     id: this.item.clientId,
    //     descricao: this.item.cliente,
    //   }
    // }
    // this.supplierSelected = {
    //   id: this.item.fornecedorId,
    //   descricao: this.item.fornecedor ?? '',
    // }
    // this.form.get('tariffType')!.setValue(this.item.tipoId)

    if (this.item.tipoTarifarioId == '1') {
      this.form.get('exclusiveCustomer')?.setValue('N')
      this.form.get('exclusiveCustomer')?.disable()
    } else if (this.item.tipoTarifarioId == '2') {
      this.form.get('exclusiveCustomer')?.setValue('S')
      this.form.get('exclusiveCustomer')?.disable()
    }

    this.form.get('serviceType')!.setValue(this.item.tipoServico)
    this.form.get('tariffType')!.setValue(this.item.tipoTarifarioId ?? 1)
    this.form.get('specificationService')!.setValue(this.item.servico)
    this.form.get('vehicleType')!.setValue(this.item.tipoVeiculo ?? '')
    this.form.get('driverType')!.setValue(this.item.tipoMotorista ?? '')
    this.form.get('origin')!.setValue(this.item.origem)
    this.form.get('destination')!.setValue(this.item.destino)

    this.form.get('serviceType')!.disable()
    this.form.get('specificationService')!.disable()
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
    this.form.get('origin')!.disable()
    this.form.get('destination')!.disable()

    this.form.get('cost')!.setValue(convertCurrency(this.supplier.custo))
    this.form
      .get('costOvertime')!
      .setValue(convertCurrency(this.supplier.custoHoraExtra))
    this.form
      .get('costKmExtra')!
      .setValue(convertCurrency(this.supplier.custoKmExtra))

    this.form.get('cost')!.disable()
    this.form.get('costOvertime')!.disable()
    this.form.get('costKmExtra')!.disable()

    const validity = new Date()

    // this.form
    //   .get('validity')!
    //   .setValue(moment(this.item.dataValidade, 'DD/MM/YYYY').toDate())

    this.form.get('validity')!.setValue(validity)
    // this.form
    //   .get('active')!
    //   .setValue(this.item.ativo.toLowerCase() == 's' ? true : false)
    // this.form.get('client')!.setValue(this.item.cliente ?? '')
    // this.form.get('supplier')!.setValue(this.item.fornecedor ?? '')
    // this.form.get('standard')!.setValue(false)
    this.form.get('urbanPerimeter')!.setValue(true)
  }

  onSelectionChangeService(event: MatSelectChange) {
    const specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
  }

  checkService(specificationService: any) {
    if (specificationService) {
      if (
        specificationService.exigeVeiculo &&
        specificationService.exigeVeiculo.toLowerCase() == 's'
      ) {
        this.form.get('vehicleType')!.setValidators(Validators.required)
        this.form.get('driverType')!.setValidators(Validators.required)
        // this.form.get('vehicleType')!.enable()
        // this.form.get('driverType')!.enable()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      } else {
        this.form.get('vehicleType')!.clearValidators()
        this.form.get('driverType')!.clearValidators()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      }
    }
  }

  onSelectionChangeTypeTarrif(event: MatSelectChange) {
    if (event.value == 1) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
      this.form.get('client')!.disable()
    } else {
      this.form.get('client')!.enable()
    }
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        if (response.remove == false) {
          this.clientSelected = response.selection
          this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
        } else {
          this.clientSelected = {}
          this.form.get('client')!.setValue('')
        }
      }
    })
  }

  openDatepicker() {
    this.datepicker()?.open()
  }
}
